<ng-floating-action-menu [placement]="config.placment" [effect]="config.effect" 
  [iconClass]="config.iconClass" [activeIconClass]="config.activeIconClass" 
  [toggle]="config.toggle" [buttons]="buttons">
</ng-floating-action-menu>

<app-abrir-modal #abrirModal></app-abrir-modal>
